import { Info, List, ListChecks, Shield } from "lucide-react";
import * as React from "react";
import { Outlet } from "react-router";

import { EntityComments } from "@/shared/components/comments";
import {
  EntityTabs,
  type EntityTabItem,
  useActiveEntityTab,
} from "@/shared/components/EntityPage";
import { CollectionRecord } from "@/shared/domain/collections";
import { CollectionTab } from "@/shared/navigation";

import styles from "./CollectionDetails.module.css";
import { CollectionHeader } from "./CollectionHeader";

const COLLECTION_TABS: EntityTabItem<CollectionTab>[] = [
  { value: CollectionTab.Items, label: "Items", icon: <List /> },
  { value: CollectionTab.Details, label: "Details", icon: <Info /> },
  { value: CollectionTab.Activity, label: "Activity", icon: <ListChecks /> },
  { value: CollectionTab.Permissions, label: "Permissions", icon: <Shield /> },
];

interface CollectionDetailsProps {
  collection: CollectionRecord;
}

export const CollectionDetails: React.FC<CollectionDetailsProps> = ({
  collection,
}) => {
  const activeTab = useActiveEntityTab(COLLECTION_TABS);

  return (
    <div className={styles.root}>
      {/* Header + tab bar */}
      <div>
        <CollectionHeader collection={collection} />

        <EntityTabs
          tabs={COLLECTION_TABS}
          activeTab={activeTab}
          aria-label="collection tabs"
        />
      </div>

      {/* Items tab needs flex-fill + internal scroll so the table fills the
          viewport. Other tabs use plain padding so <EntityComments> sits
          directly under the content rather than being pushed to the bottom. */}
      <div
        className={
          activeTab === CollectionTab.Items
            ? styles.itemsOutlet
            : styles.tabPanel
        }
      >
        <Outlet context={collection} />
      </div>

      <div className={styles.commentsSection}>
        <EntityComments
          entityType="collection"
          entityId={collection.collection_id}
        />
      </div>
    </div>
  );
};
